import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { dasa } from 'src/classess/dasaClasses';

export interface ApiResponse<T> {
  success: boolean;
  message: string;
  statusCode: number;
  data?: T;
}

@Injectable({
  providedIn: 'root'
})
export class StoreConfigurationsService {

  private baseUrl = environment.NEW_BACKEND_URL+'api/storeConfigurations';

  constructor(private http: HttpClient) {}

  /**
   * Get store configurations by storeId
   * @param storeId 
   * @returns Observable<ApiResponse<StoreConfiguration>>
   */
  getStoreConfigurations(storeId: number): Observable<ApiResponse<dasa.StoreConfiguration>> {
    return this.http.get<ApiResponse<dasa.StoreConfiguration>>(`${this.baseUrl}/get/${storeId}`);
  }

  /**
   * Create or update store configurations
   * @param config 
   * @returns Observable<ApiResponse<StoreConfiguration>>
   */
  createOrUpdateStoreConfigurations(config: dasa.StoreConfiguration): Observable<ApiResponse<dasa.StoreConfiguration>> {
    return this.http.post<ApiResponse<dasa.StoreConfiguration>>(`${this.baseUrl}/createOrUpdate`, config);
  }
}
